import z from 'zod'

import { ENDPOINT } from '@/config/endpoint'
import { apiFactory, apiOk } from '@/libs/api'
import { zh } from '@/libs/utils/zod'
import type { RecordId } from '@/types/common'

import { ItemMasterDto } from '../dto/item-master-dto'

type ItemMasterMutation = Pick<ItemMasterDto, 'name' | 'desc' | 'type' | 'categoryId' | 'units'>

export const itemMasterApi = {
  list: apiFactory({
    url: ENDPOINT.inventory.master.list,
    method: 'get',
    schema: {
      result: apiOk(z.object({ items: ItemMasterDto.array() })),
    },
  }),
  detail: apiFactory({
    url: ENDPOINT.inventory.master.detail,
    method: 'get',
    schema: {
      params: zh.ParamsId,
      result: apiOk(z.object({ item: ItemMasterDto })),
    },
  }),
  create: apiFactory({
    url: ENDPOINT.inventory.master.create,
    method: 'post',
    schema: {
      body: z.custom<ItemMasterMutation>(),
    },
  }),
  update: apiFactory({
    url: ENDPOINT.inventory.master.update,
    method: 'put',
    schema: {
      body: z.custom<RecordId & ItemMasterMutation>(),
    },
  }),
}
